import React from 'react'
import {
  DetailsForm,
  HorizontalDivider,
  FormGroup,
  FormLabel,
  AgreeContainer,
  PrivacyLink,
} from '../styled'
import FormInput from '../FormInput'

// import Heading from '../Heading'
type Input = {
  value: string | boolean | number
  setValue: (newValue) => void
  error: boolean
}

const getValidationByCondition = (
  value,
  expresionPassed = false,
  minLength = 3,
) => {
  if (!expresionPassed) {
    return false
  }
  if (minLength) {
    if (value.length < minLength) {
      return false
    }
  }
  if (value !== '') {
    return true
  }
  return false
}
/* eslint-disable no-useless-escape */
const EmailExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const PhoneExp = /^[0-9 \(\)]+$/
const countryCodeExp = /^[0-9 \+\(\)]+$/

const focus = (e: React.PointerEvent<HTMLInputElement>) => {
  e.preventDefault()
  const inputElement = e.target as HTMLInputElement
  setTimeout(() => {
    inputElement.focus()
  })
}

const DetailsStep: React.FC<{
  input: Input[]
  variant: string
}> = ({ input, variant }) => {
  console.log(variant)
  const toggleChecked = (e: React.PointerEvent<HTMLInputElement>) => {
    const inputElement = e.target as HTMLInputElement
    inputElement.checked = !inputElement.checked
    input[6].setValue(inputElement.checked)
  }
  return (
    <>
      <DetailsForm
        method="POST"
        onSubmit={(e) => e.preventDefault()}
        noValidate
      >
        <HorizontalDivider>
          <FormGroup
            variant={variant}
            className={[
              input[0].value &&
                getValidationByCondition(input[0].value) &&
                'validated',
              input[0].error ? 'left error' : 'left',
            ]}
          >
            <FormInput
              formProperties={{
                error: input[0].error,
                id: 'pronoun',
                type: 'text',
                value: input[0].value,
                isRequired: false,
                updater: (e) => input[0].setValue(e.target.value),
                onFocus: (e) => focus(e),
              }}
            />
            <FormLabel className="label">pronoun</FormLabel>
          </FormGroup>
          <FormGroup
            variant={variant}
            className={[
              input[1].value &&
                getValidationByCondition(input[1].value, input[1].error) &&
                'validated',
              input[1].error ? 'right error' : 'right',
            ]}
          >
            <FormInput
              formProperties={{
                error: input[1].error,
                id: 'firstname',
                type: 'text',
                value: input[1].value,
                updater: (e) => input[1].setValue(e.target.value),
                onFocus: (e) => focus(e),
              }}
            />
            <FormLabel className="label">first name</FormLabel>
          </FormGroup>
        </HorizontalDivider>
        <FormGroup
          variant={variant}
          className={[
            input[2].value &&
              getValidationByCondition(input[2].value, input[2].error) &&
              'validated',
            input[2].error ? 'error' : '',
          ]}
        >
          <FormInput
            formProperties={{
              error: input[2].error,
              id: 'lastname',
              type: 'text',
              value: input[2].value,
              updater: (e) => input[2].setValue(e.target.value),
              onFocus: (e) => focus(e),
            }}
          />
          <FormLabel className="label">last name</FormLabel>
        </FormGroup>
        <FormGroup
          variant={variant}
          className={[
            input[3].value &&
              getValidationByCondition(
                input[3].value,
                EmailExp.test(input[3].value?.toString()),
              ) &&
              'validated',
            input[3].error ? 'error' : '',
          ]}
        >
          <FormInput
            formProperties={{
              error: input[3].error,
              id: 'email',
              type: 'text',
              value: input[3].value,
              updater: (e) => input[3].setValue(e.target.value),
              onFocus: (e) => focus(e),
            }}
          />
          <FormLabel className="label">email address</FormLabel>
        </FormGroup>
        <HorizontalDivider>
          <FormGroup
            variant={variant}
            className={[
              getValidationByCondition(
                input[4].value,
                countryCodeExp.test(input[4].value?.toString()),
                0,
              ) && 'validated',
              input[4].error ? 'left error' : 'left',
            ]}
          >
            <FormInput
              formProperties={{
                error: input[4].error,
                id: 'country-code',
                type: 'text',
                value: input[4].value,
                updater: (e) => input[4].setValue(e.target.value),
                onFocus: (e) => focus(e),
              }}
            />
            <FormLabel className="label">country code</FormLabel>
          </FormGroup>
          <FormGroup
            variant={variant}
            className={[
              input[5].value &&
                getValidationByCondition(
                  input[5].value,
                  PhoneExp.test(input[5].value?.toString()),
                ) &&
                'validated',
              input[5].error ? 'right error' : 'right',
            ]}
          >
            <FormInput
              formProperties={{
                error: input[5].error,
                id: 'phone',
                type: 'tel',
                value: input[5].value,
                updater: (e) => input[5].setValue(e.target.value),
                onFocus: (e) => focus(e),
              }}
            />
            <FormLabel className="label">phone number</FormLabel>
          </FormGroup>
        </HorizontalDivider>
        <AgreeContainer>
          <div>
            <input
              type="checkbox"
              className={input[6].error ? 'checkbox error' : 'checkbox'}
              onPointerUp={toggleChecked}
              checked={input[6].value}
            />
            <span>
              <span className="text">I agree with </span>
              <PrivacyLink
                data-url
                href="/privacy-and-policy"
                variant={variant}
              >
                Ohpen&apos;s privacy policy
              </PrivacyLink>
            </span>
          </div>
        </AgreeContainer>
      </DetailsForm>
    </>
  )
}

export default DetailsStep
